module.exports = __webpack_public_path__ + "static/media/paw.666334e5.png";